import React from 'react';

const UserAggrement = () => {
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="text-center">
                <h1 className="text-4xl font-bold mb-6">Kullanıcı Sözleşmesi</h1>
                <p>Here you can put your user agreement content...</p>
            </div>
        </div>
    );
};

export default UserAggrement;
